// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeYAxisMetrics.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeYAxisMetrics component
 */

import m from 'mobx';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Metrics from 'share/components/controls/Izenda.Metrics';
import GaugeValueMetricItem from './Izenda.GaugeValueMetricItem';
import { compact, size, pick, assign, head, filter } from 'lodash/fp';

@observer
export default class GaugeYAxisMetrics extends Component {
  componentWillMount() {
    this.updateDataSource();
  }

  componentWillReceiveProps() {
    this.updateDataSource();
  }

  componentWillUpdate() {
    this.updateContainerElement();
  }

  render() {
    const props = this.props;
    const state = this.state;
    const type = props.type;
    const reportPart = props.reportPart;
    let itemProps = pick(['reportPart', 'store'], props);
    const dataSource = state.dataSource;
    const container = reportPart.reportPartContent && reportPart.reportPartContent.values;

    itemProps = assign(itemProps, {
      onDeleteElement: handleDeleteElement.bind(this),
      onAddElement: handleAddElement.bind(this),
      onUpdateElement: handleUpdateElement.bind(this),
      type,
      canDelete: dataSource.length > 1
    });

    return (
      <Metrics
        maximumMetrics={props.maximumField}
        dataSource={dataSource}
        onAddMetric={onAddMetric.bind(this)}
        onDeleteMetric={onDeleteMetric.bind(this)}
        itemComponent={GaugeValueMetricItem}
        {...itemProps}
      />
    );

    function handleDeleteElement(index, deleteElement) {
      this.state.dataSource[index] = null;
      this.setState({
        dataSource: this.state.dataSource
      });
    }

    function handleAddElement(index, field, querySource, addedField) {
      this.state.dataSource[index] = field;
      this.setState({
        dataSource: this.state.dataSource
      });
    }

    function handleUpdateElement(element, index) {
      container.elements[index] = m.toJS(element);
    }

    function onAddMetric() {
      this.state.dataSource.push(null);
      this.setState({
        dataSource: this.state.dataSource
      });
    }

    function onDeleteMetric(index) {
      this.state.dataSource.splice(index, 1);
      this.setState({
        dataSource: this.state.dataSource
      });
    }
  }

  updateContainerElement() {
    const props = this.props;
    const store = props.store;
    const reportFilters = store.reportFilters;
    const reportPart = props.reportPart;
    const newDataSource = compact(this.state.dataSource);
    const valueElements = reportPart.reportPartContent.values.elements;
    const numNewValues = size(newDataSource);
    const numValues = size(valueElements);

    if (numNewValues === numValues) {
      return;
    }

    if (numNewValues < numValues) {
      let deletedElement = filter(elm => !newDataSource.includes(elm), valueElements);
      deletedElement = head(deletedElement);

      if (deletedElement) {
        reportPart.removeFieldFromContainer(reportPart.reportPartContent.values, deletedElement);
        reportFilters.removeAggregatedField(deletedElement);
        reportPart.shouldUpdatePreview && props.store.needUpdatePreview(reportPart);
      }
    } else {
      reportPart.reportPartContent.values.elements = newDataSource;
    }
  }

  updateDataSource() {
    const reportPart = this.props.reportPart;
    const container = reportPart.reportPartContent && reportPart.reportPartContent.values;
    const dataSource = [];

    container.elements.forEach(field => {
      dataSource.push(field);
    });

    // at least one metric is showed
    this.setState({
      dataSource: dataSource.length ? dataSource : [null]
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.GaugeYAxisMetrics.js